import { useEffect } from 'react';
import AddCompetence from '@/components/Competencies/CreateFlow/AddCompetence';

export const CompetenciesCourse = ({
  setAddList,
  addList,
  setDeleteList,
  deleteList,
  courseCompetencies,
  newCourseCompetencies,
  setNewCourseCompetencies,
  setIsOpenAddCompetencies,
}) => {
  useEffect(() => {
    const deletedIds = new Set(deleteList.map((item) => item.competenceId));

    const resultList = [
      ...courseCompetencies.filter(
        (item) => !deletedIds.has(item.competenceId)
      ),
      ...addList.map((item) => ({
        ...item,
      })),
    ];
    setNewCourseCompetencies(resultList);
  }, [addList, deleteList, courseCompetencies]);

  return (
    <div className="">
      <AddCompetence
        title={'pages.create_edit_course.competence_add.title_course'}
        text={'pages.create_edit_course.competence_add.text_course'}
        info_text={'pages.create_edit_course.competence_add.info_text_course'}
        setDeleteList={setDeleteList}
        setAddList={setAddList}
        addList={addList}
        listCompetencies={newCourseCompetencies}
        setIsOpenAddCompetencies={setIsOpenAddCompetencies}
      />
    </div>
  );
};
